<template>
  <div
    class="soha-triple-choice-container"
    :class="{ active: active }"
  >
    <span
      v-for="(button, index) in buttons"
      :key="button.id"
      :name="name + index"
      :class="{ selected: button.id === +modelValue }"
      @click="select(button.id)"
    >
      {{ button.text }}
    </span>
  </div>
</template>

<script>
import "@/assets/css/components/base/triple-choice.css";

export default {
  name: "TripleChoice",

  props: {
    modelValue: {
      type: [String, Number],
      default: null,
    },
    active: {
      type: Boolean,
      default: true,
    },
    buttons: {
      type: Array,
      required: true,
    },
    name: {
      type:String,
      default: null,
    },
  },

  emits: ['update:modelValue', 'change'],

  setup(props, { emit }) {
    const select = (id) => {
      if (props.active) {
        emit('update:modelValue', id);
        emit('change', id);
      }
    };

    return {
      select
    };
  }
};
</script>